<template>
  <div class="admissionsAdmin">
    <el-card shadow="always">
      <el-form
        ref="formInline"
        size="small"
        label-width="110px"
        :model="formInline"
        inline
      >
        <el-form-item label-width="60px" prop="question" label="问题">
          <el-input
            clearable
            style="width: 230px"
            v-model.trim="formInline.question"
            placeholder="请输入问题"
          ></el-input>
        </el-form-item>
        <el-form-item prop="speechcraftClassifyId" label="话术分类">
          <el-select
            style="width: 230px"
            v-model="formInline.speechcraftClassifyId"
            placeholder="请选择话术分类"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option
              v-for="item in speechcraftClassifyData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
            <el-option
              label="--"
              :value="0"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label-width="140px"
          prop="isRecommend"
          label="搜索框推荐状态"
        >
          <el-select
            style="width: 230px"
            v-model="formInline.isRecommend"
            placeholder="请选择搜索框推荐状态"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="未推荐" value="2"></el-option>
            <el-option label="已推荐" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: 30px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset" style="margin-left: 8px"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px" shadow="always">
      <div class="title">
        <el-button
          size="small"
          type="primary"
          @click="openHandleTechnicalDialogue('add')"
          >新建</el-button
        >
        <el-button size="small" type="primary" @click="openSetVerbalTrick"
          >话术分类管理</el-button
        >
      </div>
      <el-table border v-loading="loading" :data="data" style="width: 100%">
        <el-table-column label="ID" width="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.id || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="话术分类" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{
              handleSpeechcraftClassifyId(row.speechcraftClassifyId)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="排序号" width="130" align="center">
          <template slot-scope="{ row }">
            <span>
              {{ row.sortNum || row.sortNum === 0 ? row.sortNum : "--" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="问题" minWidth="200" align="center">
          <template slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" popper-class="tooltip" placement="top">
              <div slot="content" class="tooltip">{{ row.question || '--' }}</div>
              <div class="ellipsis">{{ row.question || "--" }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="对应话术" minWidth="240" align="center">
          <template slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" popper-class="tooltip" placement="top">
              <div slot="content" class="tooltip">{{ row.answer || '--' }}</div>
              <div class="ellipsis">{{ row.answer || "--" }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="搜索框推荐状态" width="150" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.isRecommend === 2">未推荐</el-tag>
            <el-tag type="success" v-else-if="row.isRecommend === 1"
              >已推荐</el-tag
            >
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column width="200" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <span
              class="blue_Box"
              @click="openHandleTechnicalDialogue('alter', row)"
              >编辑</span
            >
            <span
              class="blue_Box"
              v-if="row.isRecommend === 2"
              @click="handleRecommend('1', row.id)"
              >推荐</span
            >
            <span
              class="blue_Box"
              v-else-if="row.isRecommend === 1"
              @click="handleRecommend('2', row.id)"
              >取消推荐</span
            >
            <span class="blue_Box" @click="handleDelete(row.id)">删除</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>

    <!-- 话术分类管理 -->
    <SetVerbalTrick ref="setVerbalTrickRef" />
    <!-- 新建、编辑 -->
    <HandleTechnicalDialogue ref="handleTechnicalDialogueRef" />
  </div>
</template>

<script>
import {
  delCmsSpeechcraft,
  updateCmsSpeechcraft,
  getCmsSpeechcraftListPage,
  getSpeechcraftClassifyListPage,
} from "@/api/marketingAdmin/technicalDialogue.js";
import SetVerbalTrick from "@/views/marketingAdmin/components/setVerbalTrick.vue";
import HandleTechnicalDialogue from "@/views/marketingAdmin/components/handleTechnicalDialogue.vue";
import myPagination from "@/components/myPagination.vue";
import { clone, processing } from "@/utils/handle.js";
export default {
  components: {
    myPagination,
    SetVerbalTrick,
    HandleTechnicalDialogue,
  },
  data() {
    return {
      loading: false,
      formInline: {
        question: "",
        speechcraftClassifyId: "-1",
        isRecommend: "-1",
      },
      data: [],
      speechcraftClassifyData: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      searchData: {},
    };
  },
  created() {
    this.getCmsSpeechcraftListPage({ page: 1, limit: 10 });
    this.getSpeechcraftClassifyListPage({ page: 1, limit: -1 });
  },
  methods: {
    // 推荐、取消
    handleRecommend(isRecommend, id) {
      let message = isRecommend === "1" ? "推荐" : "取消推荐";
      this.$confirm(`您确认要${message}吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        updateCmsSpeechcraft({ isRecommend, id }).then((res) => {
          if (res.code === 0) {
            this.refresh();
            this.$message({
              type: "success",
              message: `${message}成功`,
            });
          }
        });
      });
    },
    // 删除
    handleDelete(id) {
      this.$confirm("确认要删除该招生话术吗?", "提示", {
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCmsSpeechcraft({ id }).then((res) => {
            if (res.code === 0) {
              if (this.pageInfo.total >= this.pageInfo.limit) {
                let sum = this.pageInfo.total % this.pageInfo.limit;
                if (sum === 1) {
                  this.pageInfo.page =
                    Number(this.pageInfo.page) === 1
                      ? 1
                      : Number(this.pageInfo.page) - 1;
                }
              }
              this.refresh();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {});
    },
    // 话术分类
    handleSpeechcraftClassifyId(payload) {
      if (!payload) return "--";
      let arr = this.speechcraftClassifyData.find((item) => {
        return item.id === payload;
      });
      return arr?.name || payload;
    },
    // 话术分类列表
    async getSpeechcraftClassifyListPage() {
      const res = await getSpeechcraftClassifyListPage({ page: 1, limit: -1 });
      this.speechcraftClassifyData = res.data?.records || [];
    },
    // 新建、编辑
    openHandleTechnicalDialogue(status, payload) {
      this.$refs.handleTechnicalDialogueRef.init(status, payload);
    },
    // 打开话术分类管理
    openSetVerbalTrick() {
      this.$refs.setVerbalTrickRef.init();
    },
    // 刷新
    refresh() {
      this.getCmsSpeechcraftListPage(
        Object.assign(this.searchData, {
          page: this.pageInfo.page,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 请求列表
    async getCmsSpeechcraftListPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      const res = await getCmsSpeechcraftListPage({ ...payload });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    // 搜索
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.getCmsSpeechcraftListPage(
        Object.assign(processing(this.formInline), { page: 1, limit: 10 })
      );
    },
    // 重置
    handleReset() {
      this.searchData = {};
      this.$refs["formInline"].resetFields();
      this.getCmsSpeechcraftListPage({ page: 1, limit: 10 });
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getCmsSpeechcraftListPage(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getCmsSpeechcraftListPage(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.admissionsAdmin {
  .title {
    margin: 0px 0 10px;
  }

  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }

  ::v-deep .ellipsis {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;
    word-wrap:break-word;
  }
}

.tooltip {
  width: 800px !important;
}
</style>